import React, { createContext, useState, ReactNode } from "react";

export type PopupPayload = {
  status: number;
  message: string;
  onOk?: () => void;
  messageType?: string;
  messageCode?: string;
};

export type PopupState = {
  show: boolean;
  status?: number;
  message?: string;
  onOk?: (() => void) | null;
  messageType?: string;
  messageCode?: string;
};

export type PopupContextType = {
  showPopup: (payload: PopupPayload) => void;
  hidePopup: () => void;
  popupData: PopupState;
};

const PopupContext = createContext<PopupContextType | null>(null);

export const PopupProvider = ({ children }: { children: ReactNode }) => {
  const [popupData, setPopupData] = useState<PopupState>({ show: false });

  const showPopup = (payload: PopupPayload) => {
    setPopupData({
      show: true,
      status: payload.status,
      message: payload.message,
      onOk: payload.onOk ?? null,
      messageType: payload.messageType,
      messageCode: payload.messageCode,
    });
  };

  const hidePopup = () => setPopupData({ show: false });

  return (
    <PopupContext.Provider value={{ showPopup, hidePopup, popupData }}>
      {children}
    </PopupContext.Provider>
  );
};

export default PopupContext;
